import React, { memo } from 'react';

import { Page } from '@bonanza-social/navigation';
import { MetaGame } from '../../components';
import { MetaGameModalProps } from './MetaGameModal.types';

function MetaGameModal({ route }: MetaGameModalProps) {
  const { gameType } = route.params;

  return (
    <Page>
      <MetaGame gameType={gameType} />
    </Page>
  );
}

export default memo(MetaGameModal);
